import React, { Component } from 'react';
import classNames from 'classnames';
import AADService from '../Azure/AADService';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as proyectAction from "../../store/actions/proyectAction";

class AppProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            given_name:this.props.global.user!==null?this.props.global.user.given_name:null
        };
        this.onClick = this.onClick.bind(this);
        this.AzureADService = new AADService();
    }
    componentDidMount() {
        //this.datosUsuario();
    }
    datosUsuario(){
        const user=(this.props.global.user);
        if(user!==undefined && user!==null){
            this.setState({
                given_name: user.given_name,
            });
        }        
    }
    onClick(event) {
        this.setState({expanded: !this.state.expanded});
        event.preventDefault();
    }

    Opciones(){
        return(
            <div>
                <button className="p-link layout-profile-link" onClick={this.onClick}>
                    <span className="username">{this.state.given_name}</span>
                    <i className="pi pi-fw pi-cog"/>
                </button>
                <ul className={classNames({'layout-profile-expanded': this.state.expanded})}>
                    <li>

                    </li>                    
                </ul>
            </div>
        );    
    }

    render() {
        return  (
            <div className="layout-profile">
                <div className="">
                    <span className="username ">{this.state.given_name}</span>                
                </div>
                                
            </div>
        );
    }
}
const mapStateToProps = (rootReducer) => {
    return {global: rootReducer.proyect};
};
export default connect(mapStateToProps, proyectAction)(withTranslation ("translations") (AppProfile));